import {
    GET_CLOVER_SETTINGS_STARTED,
    GET_CLOVER_SETTINGS_SUCCESS,
    GET_CLOVER_SETTINGS_FAILURE,
    UPDATE_CLOVER_SETTINGS_STARTED,
    UPDATE_CLOVER_SETTINGS_SUCCESS,
    UPDATE_CLOVER_SETTINGS_FAILURE,
    LOG_IN_CLOVER_STARTED,
    LOG_IN_CLOVER_SUCCESS,
    LOG_IN_CLOVER_FAILURE,
    CREATE_CLOVER_PAYMENT_STARTED,
    CREATE_CLOVER_PAYMENT_SUCCESS,
    CREATE_CLOVER_PAYMENT_FAILURE,
    CREATE_TIP_REQUEST_STARTED,
    CREATE_TIP_REQUEST_SUCCESS,
    CREATE_TIP_REQUEST_FAILURE,
    DISPLAY_RECEIPT_OPTION_STARTED,
    DISPLAY_RECEIPT_OPTION_SUCCESS,
    DISPLAY_RECEIPT_OPTION_FAILURE,
    PRINT_CLOVER_RECEIPT_STARTED,
    PRINT_CLOVER_RECEIPT_SUCCESS,
    PRINT_CLOVER_RECEIPT_FAILURE,
    DISPLAY_WELCOME_MESSAGE_STARTED,
    DISPLAY_WELCOME_MESSAGE_SUCCESS,
    DISPLAY_WELCOME_MESSAGE_FAILURE,
    CHECK_DEVICE_CONNECTION_STARTED,
    CHECK_DEVICE_CONNECTION_SUCCESS,
    CHECK_DEVICE_CONNECTION_FAILURE,
    SWITCH_CONNECTION_STARTED,
    SWITCH_CONNECTION_SUCCESS,
    SWITCH_CONNECTION_FAILURE,
    SET_DEFAULT_DEVICE_CLOVER_STARTED,
    SET_DEFAULT_DEVICE_CLOVER_SUCCESS,
    SET_DEFAULT_DEVICE_CLOVER_FAILURE,
    DISCONNECT_CLOVER_DEVICES_STARTED,
    DISCONNECT_CLOVER_DEVICES_SUCCESS,
    DISCONNECT_CLOVER_DEVICES_FAILURE,
    RESET_STATUS,
    LOG_OUT_CLOVER,
    REMOVE_ERROR_MESSAGE,
} from "../../constants/newClover/newClover";

const initialState = {
    isAuth: false || localStorage.getItem("cloverAuth") === "true",
    connectionType: localStorage.getItem("cloverConnectionType") || "wifi",
    settings: null,
    terminals: [],
    successStep: '',
    resData: null,
    loading: false,
    message: null,
    error: null,
};
export default function newClover(state = initialState, action) {
    switch (action.type) {
        case DISCONNECT_CLOVER_DEVICES_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null
            }
        case DISCONNECT_CLOVER_DEVICES_SUCCESS:
            localStorage.removeItem("cloverAuth")
            localStorage.removeItem("CloverConnected")
            const availableConnections = localStorage.getItem('availableConnections') ? JSON.parse(localStorage.getItem('availableConnections')) : [];
            const defaultPaymentConnection = localStorage.getItem('defaultPaymentConnection') || '';
            if (defaultPaymentConnection === 'clover-local') {
                localStorage.removeItem('defaultPaymentConnection');
            }
            if (availableConnections.includes('clover-local')) {
                availableConnections.splice(availableConnections.indexOf('clover-local'), 1);
                localStorage.setItem('availableConnections', JSON.stringify(availableConnections));
            }
            return {
                ...state,
                isAuth: false,
                connectionType: "wifi",
                settings: null,
                terminals: [],
                successStep: '',
                resData: null,
                loading: false,
                message: "Disconnected from Clover successfully"
            }
        case DISCONNECT_CLOVER_DEVICES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                message: null
            }
        case LOG_IN_CLOVER_STARTED:
            return {
                ...state,
                loading: true,
            };
        case LOG_IN_CLOVER_SUCCESS:
            localStorage.setItem("cloverAuth", "true");
            return {
                ...state,
                isAuth: true,
                settings: action.payload.data,
                loading: false,
            };
        case LOG_IN_CLOVER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        case GET_CLOVER_SETTINGS_STARTED:
            return {
                ...state,
                loading: true,
            };
        case GET_CLOVER_SETTINGS_SUCCESS:
            return {
                ...state,
                settings: action.payload.settings,
                terminals: action.payload.terminals,
                loading: false,
            };
        case GET_CLOVER_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };

        case UPDATE_CLOVER_SETTINGS_STARTED:
            return {
                ...state,
                loading: true,
            };
        case UPDATE_CLOVER_SETTINGS_SUCCESS:
            return {
                ...state,
                settings: action.payload.data,
                loading: false,
                message: "Clover settings updated successfully"
            };
        case UPDATE_CLOVER_SETTINGS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };

        case CREATE_CLOVER_PAYMENT_STARTED:
            return {
                ...state,
            };
        case CREATE_CLOVER_PAYMENT_SUCCESS:
            return {
                ...state,
                resData: action.payload.data,
                successStep: "PAYMENT",
            };
        case CREATE_CLOVER_PAYMENT_FAILURE:
            return {
                ...state,
                successStep: "FAILED",
                error: action.payload.error
            };
        case DISPLAY_RECEIPT_OPTION_STARTED:
            return {
                ...state,
            }
        case DISPLAY_RECEIPT_OPTION_SUCCESS:
            return {
                ...state,
                successStep: "RECEIPT"
            }
        case DISPLAY_RECEIPT_OPTION_FAILURE:
            return {
                ...state,
                successStep: "RECEIPT"
            }

        case CREATE_TIP_REQUEST_STARTED:
            return {
                ...state,
            };
        case CREATE_TIP_REQUEST_SUCCESS:
            return {
                ...state,
                resData: action.payload.data,
                successStep: "TIP",
            };
        case CREATE_TIP_REQUEST_FAILURE:
            return {
                ...state,
                successStep: "FAILED",
                error: action.payload.error
            };

        case PRINT_CLOVER_RECEIPT_STARTED:
            return {
                ...state,
            };
        case PRINT_CLOVER_RECEIPT_SUCCESS:
            return {
                ...state,
                resData: action.payload.data,
                // successStep: "RECEIPT",
            };
        case PRINT_CLOVER_RECEIPT_FAILURE:
            return {
                ...state,
                // successStep: "RECEIPT",
                error: action.payload.error
            };

        case DISPLAY_WELCOME_MESSAGE_STARTED:
            return {
                ...state,
            };
        case DISPLAY_WELCOME_MESSAGE_SUCCESS:
            return {
                ...state,
                resData: action.payload.data,
                successStep: "SUCCESS",
            };
        case DISPLAY_WELCOME_MESSAGE_FAILURE:
            return {
                ...state,
                successStep: "SUCCESS",
                error: action.payload.error
            };

        case CHECK_DEVICE_CONNECTION_STARTED:
            return {
                ...state,
            };
        case CHECK_DEVICE_CONNECTION_SUCCESS:
            return {
                ...state,
                resData: action.payload.data,
                successStep: "CONNECTED",
            };
        case CHECK_DEVICE_CONNECTION_FAILURE:
            return {
                ...state,
                successStep: "FAILED",
                error: action.payload.error
            };

        case SWITCH_CONNECTION_STARTED:
            return {
                ...state,
                loading: true,
            };
        case SWITCH_CONNECTION_SUCCESS:
            const { isCloudConnection } = action.payload;
            const connectionType = isCloudConnection ? "cloud" : "wifi";
            localStorage.setItem("cloverConnectionType", connectionType);
            return {
                ...state,
                connectionType: connectionType,
                loading: false,
            };
        case SWITCH_CONNECTION_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };
        case SET_DEFAULT_DEVICE_CLOVER_STARTED:
            return {
                ...state,
                loading: true,
            };
        case SET_DEFAULT_DEVICE_CLOVER_SUCCESS:
            return {
                ...state,
                settings: { ...state.settings, defaultDevice: action.payload.defaultDevice },
                loading: false,
                message: "Default device updated successfully"
            };
        case SET_DEFAULT_DEVICE_CLOVER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };

        case RESET_STATUS:
            return {
                ...state,
                successStep: '',
            };

        case REMOVE_ERROR_MESSAGE:
            return {
                ...state,
                loading: false,
                error: null,
                message: null
            };

        case LOG_OUT_CLOVER:
            localStorage.removeItem("cloverAuth");
            return {
                ...state,
                isAuth: false,
                settings: null,
            };

        default:
            return {
                ...state,
            };
    }
}